import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { CUSTOMERS_CRUD_ACTION_CREATORS } from '../actions/customers_actions';

export const customersRestCrudThunksForBuyer = new RestCrudThunks(
	'buyers',
	'buyer',
	'buyer',
	'buyers',
	CUSTOMERS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	''
);
export const customersRestCrudThunksForSupplier = new RestCrudThunks(
	'buyers',
	'buyer',
	'buyer',
	'buyers',
	CUSTOMERS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	''
);
